var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "text-align": "left" } }, [
    (this.onlyDash != null) & (this.canCreate == null)
      ? _c("section", { staticStyle: { "list-style-type": "none" } }, [
          this.onlyDash === true
            ? _c(
                "div",
                _vm._l(_vm.options.dashboards, function(dash, index) {
                  return _c(
                    "b-dropdown-item",
                    {
                      key: "dash" + index,
                      attrs: { disabled: _vm.hasNoDash },
                      on: {
                        click: function($event) {
                          return _vm.onShowDashboard(dash)
                        }
                      }
                    },
                    [
                      _vm.hasIcon
                        ? _c(
                            "svg",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("g", { attrs: { fill: "none" } }, [
                                _c("path", {
                                  attrs: {
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    d:
                                      "M5.5 8.757C5.5 6.958 7.067 5.5 9 5.5s3.5 1.458 3.5 3.257c0 1.785-1.117 3.868-2.86 4.613a1.64 1.64 0 0 1-1.28 0c-1.743-.745-2.86-2.828-2.86-4.613Z"
                                  }
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    stroke: "currentColor",
                                    "stroke-linecap": "round",
                                    "stroke-width": "1.5",
                                    d:
                                      "m14 14l6.5 6.5M14 14l-7.605 7.605M14 14l2-2m5.607-5.606L19 9"
                                  }
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M10 9a1 1 0 1 1-2 0a1 1 0 0 1 2 0"
                                  }
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    stroke: "currentColor",
                                    "stroke-linecap": "round",
                                    "stroke-width": "1.5",
                                    d:
                                      "M2 12c0 4.714 0 7.071 1.464 8.535C4.93 22 7.286 22 12 22s7.071 0 8.535-1.465C22 19.072 22 16.714 22 12s0-7.071-1.465-8.536C19.072 2 16.714 2 12 2S4.929 2 3.464 3.464c-.973.974-1.3 2.343-1.409 4.536"
                                  }
                                })
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" " + _vm._s(dash.name))
                    ]
                  )
                }),
                1
              )
            : this.onlyDash === false && _vm.options.dashboards.length != 0
            ? _c(
                "div",
                [
                  _c(
                    "b-dropdown-group",
                    { attrs: { header: "Dashboards" } },
                    _vm._l(_vm.options.dashboards, function(dash, index) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: "dash" + index,
                          attrs: { disabled: _vm.hasNoDash },
                          on: {
                            click: function($event) {
                              return _vm.onShowDashboard(dash)
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1"
                                  }
                                },
                                [
                                  _c("rect", {
                                    attrs: {
                                      width: "18.5",
                                      height: "18.5",
                                      x: "2.75",
                                      y: "2.75",
                                      "stroke-width": "1.5",
                                      rx: "6"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      "stroke-linecap": "round",
                                      "stroke-width": "1.6",
                                      d:
                                        "M7.672 16.222v-5.099m4.451 5.099V7.778m4.205 8.444V9.82"
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" " + _vm._s(dash.name))
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    this.canCreate != null
      ? _c("section", { staticStyle: { "list-style-type": "none" } }, [
          _c(
            "div",
            _vm._l(_vm.options.dashboards, function(dash, index) {
              return _c(
                "b-dropdown-item",
                {
                  key: "dash" + index,
                  attrs: { disabled: _vm.hasNoDash },
                  on: {
                    click: function($event) {
                      return _vm.onCreateDashboard(dash)
                    }
                  }
                },
                [
                  _vm.hasIcon
                    ? _c(
                        "svg",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24"
                          }
                        },
                        [
                          _c("g", { attrs: { fill: "none" } }, [
                            _c("path", {
                              attrs: {
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                d:
                                  "M5.5 8.757C5.5 6.958 7.067 5.5 9 5.5s3.5 1.458 3.5 3.257c0 1.785-1.117 3.868-2.86 4.613a1.64 1.64 0 0 1-1.28 0c-1.743-.745-2.86-2.828-2.86-4.613Z"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                stroke: "currentColor",
                                "stroke-linecap": "round",
                                "stroke-width": "1.5",
                                d:
                                  "m14 14l6.5 6.5M14 14l-7.605 7.605M14 14l2-2m5.607-5.606L19 9"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M10 9a1 1 0 1 1-2 0a1 1 0 0 1 2 0"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                stroke: "currentColor",
                                "stroke-linecap": "round",
                                "stroke-width": "1.5",
                                d:
                                  "M2 12c0 4.714 0 7.071 1.464 8.535C4.93 22 7.286 22 12 22s7.071 0 8.535-1.465C22 19.072 22 16.714 22 12s0-7.071-1.465-8.536C19.072 2 16.714 2 12 2S4.929 2 3.464 3.464c-.973.974-1.3 2.343-1.409 4.536"
                              }
                            })
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" " + _vm._s(dash.name))
                ]
              )
            }),
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }